import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="download" />;

export const Route = createFileRoute("/en/thank-you/download")({
  head: () => buildRouteHead("/en/thank-you/download"),
  component: ThankYouRoute,
});

